import classNames from 'classnames';
import { LabelProps, Label } from './Label';
export function LabelTelescope(props: LabelProps) {
    return (
        <Label
            {...props}
            class={classNames(props.class, 'font-telescope')}
            variant="text-lg"
        />
    );
}
